import { Transcription, UpdateTranscriptionDto } from '../models/transcription'
import { baseApi, Tag } from './base'
import { cacher } from '@/utils/rtkQueryCacheUtils'

export const TranscriptionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTranscription: builder.query<Transcription, string>({
      query: (transcriptionId) => ({
        url: `transcriptions/${transcriptionId}`,
        method: 'GET',
      }),
      providesTags: cacher.cacheByIdArg(Tag.TRANSCRIPTION),
    }),
    updateTranscriptionInfo: builder.mutation<Transcription, { transcriptionId: string; body: UpdateTranscriptionDto }>({
      query: ({ transcriptionId, body }) => ({
        url: `transcriptions/${transcriptionId}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: (_result, _error, { transcriptionId }) => [{ type: Tag.TRANSCRIPTION, id: transcriptionId }],
    }),
    deleteTranscription: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `transcriptions/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, _error, { id }) => [{ type: Tag.TRANSCRIPTION, id }],
    }),
    transcribeFromFile: builder.mutation<Transcription, { file: File; consultationId: string; userId: string }>({
      query: ({ file, consultationId, userId }) => {
        const formData = new FormData()
        formData.append('file', file)
        formData.append('consultationId', consultationId)
        formData.append('userId', userId)
        return {
          url: 'transcriptions/from-file',
          method: 'POST',
          body: formData,
        }
      },
    }),
  }),
})
